import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface AppointmentsFilterSectionProps {
  title: string;
  isOpen?: boolean;
  onToggle?: () => void;
  disabled?: boolean;
  children?: React.ReactNode;
}

export const AppointmentsFilterSection = ({
  title,
  isOpen = false,
  onToggle,
  disabled = false,
  children,
}: AppointmentsFilterSectionProps) => {
  return (
    <section className="rounded-xl border border-border bg-card">
      <button
        type="button"
        onClick={disabled ? undefined : onToggle}
        disabled={disabled}
        aria-expanded={disabled ? undefined : isOpen}
        className={cn(
          "flex min-h-11 w-full items-center justify-between gap-3 rounded-xl px-3 py-2 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
          disabled
            ? "cursor-not-allowed text-muted-foreground/60"
            : "text-foreground hover:bg-accent hover:text-foreground"
        )}
      >
        <span className="z-body-md">{title}</span>
        <span
          className={cn(
            "flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-muted-foreground transition-colors",
            !disabled && "bg-muted/50",
            !disabled && isOpen && "bg-accent text-foreground"
          )}
        >
          <ChevronDown
            className={cn(
              "h-4 w-4 transition-transform",
              isOpen && !disabled && "rotate-180"
            )}
          />
        </span>
      </button>
      {!disabled && isOpen ? (
        <div className="border-t border-border bg-muted/20 px-3 pb-3 pt-2.5">
          {children}
        </div>
      ) : null}
    </section>
  );
};
